/** Who may change a desk campaign's contact-limits switch, and who may approve one with it off.
 *  Mirrors campaign_desk/service.py: admins switch limits off and approve those campaigns;
 *  anyone on the desk may switch them back on, before approval, on a campaign from a brief. */
type Limited = { ignore_limits: boolean; status: string; origin: string; campaign_id: number | null }

export const canApprove = (role: string | undefined, dc: Limited): boolean => !dc.ignore_limits || role === 'admin'

export function limitsControl(role: string | undefined, dc: Limited): { canSwitchOff: boolean; canSwitchOn: boolean } {
  const open = dc.origin === 'brief' && dc.campaign_id == null && (dc.status === 'ready' || dc.status === 'failed')
  return {
    canSwitchOff: open && !dc.ignore_limits && role === 'admin',
    canSwitchOn: open && dc.ignore_limits,
  }
}
